const cmdSymbol = Symbol('cmds');
export class CommandManager {
    constructor(std) {
        this.std = std;
        this._commands = new Map();
        this._getCommandCtx = () => {
            return {
                std: this.std,
            };
        };
        this.createChain = (methods, _cmds) => {
            const getCommandCtx = this._getCommandCtx;
            const createChain = this.createChain;
            const pipe = this.pipe;
            const runCmds = (ctx, [cmd, ...rest]) => {
                if (cmd) {
                    cmd(ctx, data => runCmds({ ...ctx, ...data }, rest));
                }
            };
            return {
                [cmdSymbol]: _cmds,
                run: function () {
                    const ctx = getCommandCtx();
                    let success = false;
                    try {
                        const cmds = this[cmdSymbol];
                        runCmds(ctx, [
                            ...cmds,
                            (_, next) => {
                                success = true;
                                next();
                            },
                        ]);
                    }
                    catch (err) {
                        console.error(err);
                    }
                    return success;
                },
                with: function (value) {
                    const cmds = this[cmdSymbol];
                    return createChain(methods, [
                        ...cmds,
                        (_, next) => next(value),
                    ]);
                },
                inline: function (command) {
                    const cmds = this[cmdSymbol];
                    return createChain(methods, [...cmds, command]);
                },
                try: function (fn) {
                    const cmds = this[cmdSymbol];
                    return createChain(methods, [
                        ...cmds,
                        (beforeCtx, next) => {
                            let ctx = beforeCtx;
                            const chains = fn(pipe());
                            for (const chain of chains) {
                                // inject ctx in the beginning
                                chain[cmdSymbol] = [
                                    (_, next) => {
                                        next(ctx);
                                    },
                                    ...chain[cmdSymbol],
                                ];
                                const success = chain
                                    .inline((branchCtx, next) => {
                                    ctx = { ...ctx, ...branchCtx };
                                    next();
                                })
                                    .run();
                                if (success) {
                                    next(ctx);
                                    break;
                                }
                            }
                        },
                    ]);
                },
                tryAll: function (fn) {
                    const cmds = this[cmdSymbol];
                    return createChain(methods, [
                        ...cmds,
                        (beforeCtx, next) => {
                            let ctx = beforeCtx;
                            const chains = fn(pipe());
                            let allFail = true;
                            for (const chain of chains) {
                                // inject ctx in the beginning
                                chain[cmdSymbol] = [
                                    (_, next) => {
                                        next(ctx);
                                    },
                                    ...chain[cmdSymbol],
                                ];
                                const success = chain
                                    .inline((branchCtx, next) => {
                                    ctx = { ...ctx, ...branchCtx };
                                    next();
                                })
                                    .run();
                                if (success) {
                                    allFail = false;
                                }
                            }
                            if (!allFail) {
                                next(ctx);
                            }
                        },
                    ]);
                },
                ...methods,
            };
        };
        this.pipe = () => {
            const methods = {};
            const createChain = this.createChain;
            for (const [name, command] of this._commands.entries()) {
                methods[name] = function (data) {
                    const cmds = this[cmdSymbol];
                    return createChain(methods, [
                        ...cmds,
                        (ctx, next) => command({ ...ctx, ...data }, next),
                    ]);
                };
            }
            return createChain(methods, []);
        };
    }
    add(name, command) {
        this._commands.set(name, command);
        return this;
    }
}
//# sourceMappingURL=index.js.map